import { trpc } from '../lib/trpc.js';
import { LCC_CONSTANTS } from '@lcc/shared';

export function SettingsPage() {
  const health = trpc.metrics.dashboard.useQuery(undefined, { select: (d) => d.health });

  return (
    <div className="space-y-6 max-w-2xl">
      <h1 className="font-display text-3xl text-navy">Settings</h1>

      <div className="card">
        <h2 className="font-display text-xl text-navy mb-4">Integration Status</h2>
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-navy">HubSpot CRM</p>
              <p className="text-xs text-gray-500">Syncs every 5 minutes</p>
            </div>
            {health.data && (
              <span className={`text-xs font-semibold px-2 py-1 rounded ${health.data.syncStale ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'}`}>
                {health.data.syncStale ? `STALE (${health.data.lastSyncMinutesAgo}m ago)` : `LIVE (${health.data.lastSyncMinutesAgo}m ago)`}
              </span>
            )}
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-navy">Zenbooker Webhooks</p>
              <p className="text-xs text-gray-500">POST /api/webhooks/zenbooker</p>
            </div>
            {health.data && (
              <span className={`text-xs font-semibold px-2 py-1 rounded ${health.data.webhookStale ? 'bg-amber-100 text-amber-700' : 'bg-green-100 text-green-700'}`}>
                {health.data.webhookStale ? `STALE (${health.data.lastWebhookHoursAgo}h ago)` : 'ACTIVE'}
              </span>
            )}
          </div>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-navy">Meta Ads</p>
              <p className="text-xs text-gray-500">CSV upload (Phase 1)</p>
            </div>
            <a href="/upload" className="text-xs text-navy hover:text-gold transition-colors">Upload CSV →</a>
          </div>
        </div>
      </div>

      <div className="card">
        <h2 className="font-display text-xl text-navy mb-1">Unit Economics</h2>
        <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1 mb-4">
          ⚠ VAT status: <strong>NOT CHARGING</strong> — confirm with Ray Coman before quarterly close
        </p>
        <div className="grid grid-cols-2 gap-3 text-sm">
          {[
            ['Avg job value', `£${LCC_CONSTANTS.AVG_JOB_VALUE_GBP}`],
            ['Lead→booking rate', `${LCC_CONSTANTS.LEAD_TO_BOOKING_RATE * 100}%`],
            ['Direct cost %', `${LCC_CONSTANTS.DIRECT_COST_PCT * 100}%`],
            ['Capacity ceiling', `${LCC_CONSTANTS.CAPACITY_JOBS_PER_WEEK} jobs/week`],
            ['CPL green ceiling', `£${LCC_CONSTANTS.CPL_GREEN_MAX}`],
            ['CPL kill floor', `£${LCC_CONSTANTS.CPL_RED_CEILING}`],
            ['EUR/GBP fallback', LCC_CONSTANTS.EUR_TO_GBP_FALLBACK],
            ['Current daily budget', `£${LCC_CONSTANTS.CURRENT_DAILY_BUDGET_GBP}`],
          ].map(([label, value]) => (
            <div key={String(label)} className="flex justify-between border-b border-gray-50 pb-1">
              <span className="text-gray-600">{label}</span>
              <span className="font-mono font-medium text-navy">{value}</span>
            </div>
          ))}
        </div>
        <p className="mt-3 text-xs text-gray-400">
          To change these values, edit <code className="font-mono bg-cream-tint px-1 rounded">packages/shared/src/constants.ts</code> and redeploy.
        </p>
      </div>

      <div className="card">
        <h2 className="font-display text-xl text-navy mb-3">Health Check</h2>
        <a
          href="/api/health"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-secondary text-xs"
        >
          View /api/health →
        </a>
      </div>
    </div>
  );
}
